import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {parseRequestState} from "modules/utils";
import {RequestState} from "modules/enums";
import {first, get} from "lodash";

export const getJSONs = (state: IStore) => state.jsons;

export const getContestRequestStates = createSelector(getJSONs, ({requestState}) =>
	parseRequestState(requestState)
);

export const getContest = createSelector(getJSONs, ({contest}) => contest);

export const getContestFirstQuestion = createSelector(getContest, (contest) =>
	first(get(contest, "questions", []))
);

export const getIsHelpsLoading = createSelector(
	getJSONs,
	({helpsRequestState}) => helpsRequestState !== RequestState.Received
);

export const getFaqs = createSelector(getJSONs, ({faqs}) => faqs);
export const getGuidelines = createSelector(getJSONs, ({guidelines}) => guidelines);
export const getTerms = createSelector(getJSONs, ({terms}) => terms);
export const getPrizes = createSelector(getJSONs, ({prizes}) => prizes);
